import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import { Button as LeydenButton } from '@els/els-react--button';
import ThesaurusFolderIcon from '../ThesaurusFolderIcon';
import ThesaurusExpandButton from '../ThesaurusExpandButton';

import './ThesaurusItemFolderInfo.scss';

export default function ThesaurusItemFolderInfo(props) {
  const { item, title, isOpen, selected, isFolder, onToggleGroup, partiallySelected, onClickThesaurusItem } = props;

  return (
    <>
      <ThesaurusExpandButton item={item} isOpen={isOpen} isFolder={isFolder} onToggleGroup={onToggleGroup} />

      <LeydenButton
        type="link"
        title
        className="tree-view-dialog-thesaurus-item-info rx-border-none u-els-color-text e2e-thesaurus-item"
        onClick={() => {
          onClickThesaurusItem(item);
        }}>
        <ThesaurusFolderIcon selected={selected} partiallySelected={partiallySelected} />
        {title}
      </LeydenButton>
    </>
  );
}

ThesaurusItemFolderInfo.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  isFolder: PropTypes.bool.isRequired,
  onToggleGroup: PropTypes.func.isRequired,
  partiallySelected: PropTypes.bool.isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
};
